import styled from 'styled-components'
import { softGray, inputShadow, mildBlue, blue } from '../../../styles/variables.js'

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-right: 20px;
`

const Title = styled.div`
  padding: 10px 0 0 0;
  font-size: 20px;
`

const Translates = styled.div`
  display: flex;
  flex-direction: column;
  background: ${softGray};
  padding: 10px;
  width: 100%;
  border-radius: 6px;
  margin-top: 10px;
`

const Existing = styled.div`
  display: flex;
  flex-direction: column;
  background: ${softGray};
  padding: 10px;
  width: 100%;
  border-radius: 6px;
  margin-top: 10px;

  &.disabled {
    opacity: 0.7;
  }
`

const ExistingItem = styled.div`
  box-shadow: ${inputShadow};
  padding: 10px;
  margin-bottom: 5px;
  cursor: pointer;
  background: white;
  &:hover {
    background: ${mildBlue};
  }

  &.selected {
    background: ${blue};
    color: white;
    &:hover {
      background: ${blue};
    }
  }
`

export default {
  Translates,
  Existing,
  ModalContent,
  ExistingItem,
  Title,
}
